<template>
    <div class="field">
        <label v-if="label">Color</label><br/>

        <div
            v-for="color in colors"
            :key="color"
            @click="$emit('input', color)"
            class="color" :style="{'background': color}">

            <div v-if="value === color" class="icon fa fa-check"></div>
        </div>

        <div class="is-clearfix"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: String },
        label: { type: Boolean, default: true },
        colors: {
            type: Array,
            default: () => ([
                '#F44336', '#673AB7', '#3F51B5',
                '#00BCD4', '#4CAF50', '#FFEB3B',
                '#795548', '#607D8B',
            ]),
        },
    },
};
</script>

<style scoped>
    .color {
        width: 5rem;
        float: left;
        height: 1.7rem;
        margin: 0.15rem;
        border-radius: 3px;
        color: white;
        cursor: pointer;
    }
</style>
